import { useState } from "react";
import { checkAuthStatus, loginRequest } from "../../api/auth";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import GradiantBorderWrapper from "../../components/gradiant-border/GradiantBorderWrapper";

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { setUser } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        setIsSubmitting(true);
        try {
            const res = await loginRequest(username, password, rememberMe);

            if (res?.data.tokens) {
                const userData = await checkAuthStatus();
                setUser(userData);
                navigate("/products");
            } else {
                toast.error("نام کاربری یا رمز عبور اشتباه است");
            }
        } catch (err) {
            toast.error("نام کاربری یا رمز عبور اشتباه است");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="w-full px-6 relative flex items-center justify-center min-h-screen bg-background">
            <span className="size-[40vw] laptop:size-[30vw] bg-[rgba(174,174,174,0.2)] tablet:blur-[120px] blur-[80px] absolute top-0 left-0 rounded-full" />
            <span className="size-[40vw] laptop:size-[30vw] bg-[rgba(174,174,174,0.2)] tablet:blur-[120px] blur-[80px] absolute bottom-0 right-0 rounded-full" />

            <form
                onSubmit={handleSubmit}
                className="w-full flex flex-col justify-start items-start gap-2 border border-white/25 p-6 rounded-2xl max-w-96 z-50"
            >
                <div className="flex justify-start items-center gap-2">
                    <img
                        src="/logo.png"
                        alt="fanavaran borna"
                        className="size-10 object-contain grayscale"
                    />
                    <h2 className="text-center text-xl text-foreground font-semibold">
                        ورود به پنل ادمین
                    </h2>
                </div>

                <p className="text-sm tablet:text-base w-full text-white/50 leading-tight mb-4 ">
                    ادمین گرامی! لطفا برای حفظ و امنیت اطلاعات فن آوران برنا از نام کاربری و رمز عبور خود محافظت کنید
                </p>

                <label
                    className="text-sm tablet:text-lg text-foreground"
                    htmlFor="username"
                >
                    نام کاربری
                </label>
                <input
                    id="username"
                    className="w-full mb-3 px-4 tablet:px-5 py-1.5 tablet:py-2.5 text-sm tablet:text-base text-foreground border border-white/25 bg-gradient-to-br from-background to-[#222] rounded-full placeholder:font-normal"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    type="text"
                    placeholder="نام کاربری خود را وارد کنید"
                    maxLength={100}
                    disabled={isSubmitting}
                />

                <label
                    className="text-sm tablet:text-lg text-foreground"
                    htmlFor="password"
                >
                    رمز عبور
                </label>
                <input
                    id="password"
                    className="w-full mb-3 px-4 tablet:px-5 py-1.5 tablet:py-2.5 text-sm tablet:text-base text-foreground border border-white/25 bg-gradient-to-br from-background to-[#222] rounded-full placeholder:font-normal"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    placeholder="رمز عبور خود را وارد کنید"
                    maxLength={100}
                    disabled={isSubmitting}
                />

                <label className="flex items-center gap-2 mt-1 cursor-pointer select-none">
                    <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                        className="size-4 accent-accent rounded-sm border border-white/30 bg-transparent cursor-pointer"
                        disabled={isSubmitting}
                    />
                    <span className="text-white/80">مرا به خاطر بسپار</span>
                </label>

                <GradiantBorderWrapper className="mt-8 w-full bg-gradient-to-r from-white via-transparent to-white rounded-lg">
                    <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`w-full text-sm tablet:text-base bg-accent text-foreground p-1.5 tablet:p-2 rounded-lg font-medium flex items-center justify-center gap-2 transition-all ${isSubmitting ? "opacity-80 cursor-not-allowed" : ""
                            }`}
                    >
                        {isSubmitting ? (
                            <>
                                <span className="size-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                                <span>در حال ورود...</span>
                            </>
                        ) : (
                            "ورود"
                        )}
                    </button>
                </GradiantBorderWrapper>
            </form>
        </div>
    );
}